import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';
import DialogContent from '@zenbusiness/zui/DialogContent';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './ChangeBillingIntervalAnnualConfirmation.style';

const ILLUSTRATION_URL =
  'https://res.cloudinary.com/zenbusiness/image/upload/v1/shared-assets/illustration/subscription-updated.svg';

export default function ChangeBillingIntervalAnnualConfirmation({ onClose }) {
  const { formatMessage } = useIntl();

  return (
    <>
      <DialogContent>
        <Styled.ConfirmationStack alignItems="center">
          <Styled.ConfirmationImage
            component="img"
            src={ILLUSTRATION_URL}
            alt={formatMessage({ id: 'dashboard.subscriptions.success.imageAlt' })}
          />
          <Styled.ConfirmationTitle size="xl" weight="bold" align="center">
            <FormattedMessage id="dashboard.subscriptions.success.title" />
          </Styled.ConfirmationTitle>
          <Text size="md" align="center" color="secondary">
            <FormattedMessage id="dashboard.subscriptions.success.body" />
          </Text>
        </Styled.ConfirmationStack>
      </DialogContent>
      <Styled.ModalActions>
        <Button
          variant="contained"
          onClick={onClose}
          clickstreamProps={{ elementName: 'billing_change_confirmation_close' }}
          data-testid="billing-change-confirmation-close"
        >
          <FormattedMessage id="dashboard.subscriptions.billingChange.confirmationClose" />
        </Button>
      </Styled.ModalActions>
    </>
  );
}

ChangeBillingIntervalAnnualConfirmation.propTypes = {
  onClose: PropTypes.func.isRequired,
};
